import { Quote, Star } from "lucide-react";
import { TESTIMONIALS, Reveal, Eyebrow } from "../lib/data";

const Testimonials = () => (
  <section id="recenzii" className="py-20 lg:py-28 bg-[#FBF7EF]" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-6">
      <Reveal className="max-w-2xl">
        <Eyebrow>Recenzii pacienți</Eyebrow>
        <h2 className="font-display text-3xl lg:text-4xl font-bold text-[#2A2521] mt-3">
          Peste 50.000 de zâmbete îngrijite
        </h2>
        <div className="mt-4 flex items-center gap-1.5">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="w-5 h-5 fill-[#A6823B] text-[#A6823B]" />
          ))}
          <span className="ml-2 text-[#6B5C43] font-medium" data-testid="rating-summary">4.9 / 5 din recenzii verificate</span>
        </div>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={(i % 3) * 0.08}>
            <div
              data-testid={`testimonial-card-${i}`}
              className="h-full bg-white rounded-2xl border border-[#EADFC6] p-7 hover:shadow-xl hover:shadow-[#A6823B]/10 hover:-translate-y-1 transition-all"
            >
              <Quote className="w-8 h-8 text-[#A6823B]/30" />
              <div className="flex gap-1 mt-3">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-[#A6823B] text-[#A6823B]" />
                ))}
              </div>
              <p className="text-[#4A3F2E] mt-3 leading-relaxed text-sm md:text-base">„{t.text}"</p>
              <div className="mt-5 flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-[#EFE7D6] text-[#A6823B] flex items-center justify-center font-display font-bold">
                  {t.initial}
                </span>
                <div>
                  <div className="font-display font-bold text-[#2A2521] text-sm">{t.name}</div>
                  <div className="text-xs text-[#8A7A5E]">{t.city}</div>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
